module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG56cc0b160f8aa84290d046f1b0e6f433.56cc0b16.png";